import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin';

export const initPhotoSwiper = () => {
	// ! Для видео разработчик придумал [data-pswp-video-src="my-video.mp4"] но оно не обязательно так как путь можно в href указать,
	// ! по этому пока можно использовать один селектор [data-pswp-src] чтобы по документу два раза не бегать
	let isPhotoswiperInited = false;

	const updateAllSrcData = $block => {
		$block.querySelectorAll('[data-pswp-src]').forEach($el => {
			$el.addEventListener('click', function (e) {
				if (!isPhotoswiperInited) {
					$block.querySelectorAll('[data-pswp-src]').forEach($el => {
						if ($el.tagName === 'IMG') {
							$el.setAttribute('data-pswp-src', $el.src);
							if (!$el.hasAttribute('data-pswp-width')) {
								$el.setAttribute('data-pswp-width', $el.naturalWidth);
								$el.setAttribute('data-pswp-height', $el.naturalHeight);
							}
						} else {
							const $video = $el.querySelector('video');
							if ($video) {
								if (!$el.hasAttribute('data-pswp-width')) {
									$el.setAttribute('data-pswp-width', $video.videoWidth);
									$el.setAttribute('data-pswp-height', $video.videoHeight);
								}
							} else {
								const $img = $el.querySelector('img');
								if ($img) {
									$el.setAttribute('data-pswp-src', $img.src);

									if (!$el.hasAttribute('data-pswp-width')) {
										$el.setAttribute('data-pswp-width', $img.naturalWidth);
										$el.setAttribute('data-pswp-height', $img.naturalHeight);
									}
								}
							}
						}
					});
				}
			});
		});
	};

	updateAllSrcData(document);

	const papiki = document.querySelectorAll('[data-pswp-papik]');
	const independents = document.querySelectorAll('a[data-pswp-independent]');

	const initPapik = $papik => {
		const lightbox = new PhotoSwipeLightbox({
			gallery: $papik,
			children: 'a',
			pswpModule: PhotoSwipe,
			tapAction: 'close',
			imageClickAction: false,
		});

		// ! if video
		new PhotoSwipeVideoPlugin(lightbox, {
			// {
			// 	width: 800,
			// 	height: 600,
			// 	type: 'video',
			// 	msrc: 'poster.jpg',
			// 	// if you're using just one source
			// 	videoSrc: 'my-video.mp4',
			// 	// Or for multiple sources;
			// 	// videoSrc: [
			// 	//   { src: 'my-video.webm', type: 'video/webm' },
			// 	//   { src: 'my-video.mp4', type: 'video/mp4' }
			// 	// ]
			// }
		});

		lightbox.init();
	};

	papiki.forEach(initPapik);

	independents.forEach($independents => {
		const lightbox = new PhotoSwipeLightbox({
			gallery: $independents,
			pswpModule: PhotoSwipe,
			tapAction: 'close',
			imageClickAction: false,
		});

		lightbox.init();

		lightbox.on('beforeOpen', e => {
			console.log('e: ', e);
		});
	});

	window.photoSwipeFunctions = {
		initPapik: initPapik,
		updateAllSrcData: updateAllSrcData,
	};
};
